@if (label()) {
  <span class="block text-sm font-medium mb-2" style="color:var(--talos-ink)">
    {{ labelText() }}@if (isRequired()) {<span class="text-talos-accent ml-0.5">*</span>}
  </span>
}
<div class="flex flex-col gap-2" [class.flex-row]="layout() === 'horizontal'" [class.flex-wrap]="layout() === 'horizontal'">
  @for (opt of options(); track optionValue(opt)) {
    <label class="flex items-center gap-2 cursor-pointer" [class.opacity-50]="isDisabled()">
      <input
        type="radio"
        class="w-4 h-4"
        style="accent-color: var(--talos-ink);"
        [name]="groupName"
        [value]="optionValue(opt)"
        [checked]="selected() === optionValue(opt)"
        [disabled]="isDisabled()"
        (change)="select(optionValue(opt))"
      />
      <span class="text-sm text-talos-ink">{{ optionLabel(opt) }}</span>
    </label>
  }
</div>
@if (invalid() && errorMessage()) {
  <app-field-message type="error" [message]="errorMessage()" />
}
